var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,13.7h10L29.8,0.6v10C29.8,12.3,31.2,13.7,32.9,13.7z M32.3,28.8H15.7c-0.1,0-0.2,0.1-0.2,0.2v6.8 c0,0.1,0.1,0.2,0.2,0.2h1.9v-1.3c0-0.6,0.4-1,1-1h10.9c0.6,0,1,0.4,1,1V36h1.9c0.1,0,0.2-0.1,0.2-0.2V29 C32.5,28.9,32.4,28.8,32.3,28.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,41.2h8.9v-5.6h-8.9V41.2z M21.6,37.4h4.7v2h-4.7C21.6,39.4,21.6,37.4,21.6,37.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,15.7c-2.8,0-5.1-2.3-5.1-5.1V0H9.6C6.8,0,4.5,2.3,4.5,5.1v37.8c0,2.8,2.3,5.1,5.1,5.1h28.8 c2.8,0,5.1-2.3,5.1-5.1V15.7H32.9z M34.5,35.8c0,1.2-1,2.2-2.2,2.2h-1.9v4.3c0,0.6-0.4,1-1,1H18.6c-0.6,0-1-0.4-1-1V38h-1.9 c-1.2,0-2.2-1-2.2-2.2V29c0-1.2,1-2.2,2.2-2.2h1.9v-3.6c0-0.6,0.4-1,1-1h10.9c0.6,0,1,0.4,1,1v3.6h1.9c1.2,0,2.2,1,2.2,2.2v6.8H34.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripPrint);
export default __webpack_public_path__ + "static/media/trip-print.dd5cbcf5f9f82eabc755698703f3692a.svg";
export { ForwardRef as ReactComponent };